/**
 * File misc.js.
 */

document.querySelectorAll('.btn.read-more').forEach((btn) => {
    btn.addEventListener("click", (e) => {
        e.preventDefault();
        const hiddenText = btn.parentElement.parentElement.parentElement.querySelector(".hidden-text");
        if (hiddenText.classList.contains("show")) {
            hiddenText.classList.remove("show");
        } else {
            hiddenText.classList.add("show");
        }
    });
})

const forgotLink = document.querySelector('#forgot-link');
if (typeof(forgotLink) != 'undefined' && forgotLink != null) {
    forgotLink.addEventListener("click", function() {
        console.log("test");
        document.querySelector(".login-form").classList.toggle("hidden");
        document.querySelector(".password-reset-form").classList.toggle("hidden");
    })

    document.querySelector('#login').addEventListener("modal-hide", function() {
        document.querySelector(".login-form").classList.remove("hidden");
        document.querySelector(".password-reset-form").classList.add("hidden");
    });
}

document.querySelectorAll(".single-video .image a").forEach(function(a) {
    a.addEventListener("click", function(e) {
        setTimeout(function() {
            document.querySelector("video.fslightbox-source").play();
        }, 100);
    })
});